import { Flex, IconButton } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '~/components/Icon';
import { StyledTextFieldRoot } from '~/components/Input/Elements/TextField';
import InputFieldWrapper from '~/components/InputFieldWrapper';
import { ModalParagraph, SignUpCardTitle } from '~/components/Text';
import {
  AllowDataProcessing,
  CheckboxError,
  ContinueBtn,
  DataProcessingContent,
  StyledCheckbox,
  StyledForm,
  StyledLink,
  SubTitleWrapper,
} from './components/Elements';

const StyledPasswordTextField = styled(StyledTextFieldRoot)`
  padding-right: 40px;
  width: 100%;
`;

const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 60%;
  transform: translateY(-50%);
`;

function FillLoginInfoAndTerms({
  formData,
  setFormData,
  errors,
  setErrors,
  isAgreedToTerms,
  setIsAgreedToTerms,
  nextStep,
}) {
  const handleCheckbox = e => {
    setIsAgreedToTerms(!!e?.target.checked);
  };
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  return (
    <>
      <SignUpCardTitle>Try Onomondo for free</SignUpCardTitle>
      <SubTitleWrapper>
        <ModalParagraph>
          Already have an account? <StyledLink href='/login'>Log in.</StyledLink>
        </ModalParagraph>
      </SubTitleWrapper>
      <StyledForm>
        <InputFieldWrapper
          label='Company email'
          errorText={errors.emailAddress}
        >
          <StyledTextFieldRoot
            autoFocus
            color='gray'
            size='2'
            name='email'
            placeholder='email@company.com'
            onChange={e => {
              setFormData({ ...formData, emailAddress: e.target.value });
              setErrors({ ...errors, emailAddress: '' });
            }}
            value={formData.emailAddress}
            error={!!errors.emailAddress}
          />
        </InputFieldWrapper>
        <InputFieldWrapper
          label='Create password'
          helpText={errors.password || 'Minimum 10 characters, an uppercase, and a number.'}
          errorText={errors.password}
        >
          <Flex
            align='center'
            position='relative'
          >
            <StyledPasswordTextField
              color='gray'
              size='2'
              name='password'
              placeholder='Create password'
              type={isPasswordShown ? 'text' : 'password'}
              value={formData.password}
              onChange={e => {
                setFormData({ ...formData, password: e.target.value });
                setErrors({ ...errors, password: '' });
              }}
              error={!!errors.password}
            />

            <StyledIconButton
              type='button'
              variant='ghost'
              radius='full'
              size='1'
              color='gray'
              onClick={() => setIsPasswordShown(prev => !prev)}
            >
              <Icon
                name='eye'
                width={20}
                height={20}
                color={null}
              />
            </StyledIconButton>
          </Flex>
        </InputFieldWrapper>
        <AllowDataProcessing error={isAgreedToTerms}>
          <StyledCheckbox
            type='checkbox'
            onChange={handleCheckbox}
            checked={!!isAgreedToTerms}
          />
          <DataProcessingContent>
            <p>
              I agree to the{' '}
              <StyledLink
                href='https://cdn.growth.onomondo.com/app/uploads/2024/07/04120814/Terms-of-Service-July-1st-2024-.pdf'
                target='_blank'
              >
                Terms of Service
              </StyledLink>
              <span> and </span>
              <StyledLink
                href='https://onomondo.com/privacy-policy/'
                target='_blank'
              >
                {' '}
                Privacy Policy
              </StyledLink>
              .
            </p>
            {!isAgreedToTerms && <CheckboxError>{errors.isAgreedToTerms}</CheckboxError>}
          </DataProcessingContent>
        </AllowDataProcessing>
        <ContinueBtn onClick={nextStep}>Continue</ContinueBtn>
      </StyledForm>
    </>
  );
}

FillLoginInfoAndTerms.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  isAgreedToTerms: PropTypes.bool,
  setIsAgreedToTerms: PropTypes.func,
  nextStep: PropTypes.func,
};

export default FillLoginInfoAndTerms;
